import { displayDefaultDateTime } from 'app/shared/util/date-utils';
import dayjs from 'dayjs';

export const columns = [
  {
    title: 'Tên',
    key: 'name',
    sorter: true,
    dataIndex: 'name',
  },
  {
    title: 'Ngày bắt đầu',
    key: 'startDate',
    sorter: true,
    dataIndex: 'startDate',
    render: item => displayDefaultDateTime(item),
  },
  {
    title: 'Ngày kết thúc',
    key: 'endDate',
    sorter: true,
    dataIndex: 'endDate',
    render: item => displayDefaultDateTime(item),
  },
];
